export default {
  trueOrFalse: 'trueOrFalse',
  answers: 'answers'
};
